import { CalendarClock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useAccountCooldownStatus, formatResume, AccountCooldownStatus } from "@/hooks/useAccountCooldownStatus";

interface Props {
  clientId?: string | null;
  scopeKey?: string | null;
  timezone?: string | null;
  className?: string;
  paused?: boolean;
}

export function WeeklyLimitBanner({ clientId, scopeKey, timezone, className = "", paused = false }: Props) {
  const { data } = useAccountCooldownStatus([clientId], scopeKey);
  const s = clientId ? data?.[clientId] : undefined;
  if (!s || !s.blocked) return null;
  const tzLabel = timezone || "IST";

  return (
    <div className={`rounded-md border border-destructive/40 bg-destructive/5 px-3 py-3 text-sm space-y-1 ${className}`}>
      <div className="flex items-start gap-2">
        <CalendarClock className="h-4 w-4 mt-0.5 shrink-0 text-destructive" />
        <div className="space-y-1">
          <p className="font-medium">
            LinkedIn has temporarily limited connection requests for {s.name}
          </p>
          <p className="text-muted-foreground">
            {paused ? "When this campaign resumes, the next check is " : "Next check "}
            <span className="font-medium text-foreground">{formatResume(s.resumes_at, timezone)}</span> ({tzLabel}).
            Connection requests resume if it goes through. Messages continue as normal.
          </p>
        </div>
      </div>
    </div>
  );
}

export function WeeklyLimitBadge({ status, timezone }: { status?: AccountCooldownStatus; timezone?: string | null }) {
  if (!status || !status.blocked) return null;
  return (
    <Badge variant="destructive" className="gap-1 max-w-full" title={`Next check ${formatResume(status.resumes_at, timezone)}. Connection requests resume if it goes through; messages continue`}>
      <CalendarClock className="h-3 w-3" /> Connections paused · next check {formatResume(status.resumes_at, timezone)}
    </Badge>
  );
}
